import { render, staticRenderFns } from "./MinPension.vue?vue&type=template&id=0bdbf480&scoped=true"
import script from "./MinPension.vue?vue&type=script&lang=js"
export * from "./MinPension.vue?vue&type=script&lang=js"
import style0 from "./MinPension.vue?vue&type=style&index=0&id=0bdbf480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdbf480",
  null
  
)

export default component.exports